import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "button-text" };
import { onBeforeUnmount, computed, watch, ref, } from 'vue';
import vuexStore from '@/vuex-store';
import { initAutoLc } from '@/locales/ko/views/user_permission_setting_dialog';
import VerticalDividedDialog from '@/templates/VerticalDividedDialog.vue';
import { getRealTimePermission } from '@/lib/real-time-permission';
import { userPermission } from '@/constants';
import { permissionSettingRequiredLevelList } from '@/constants/userPermissionSetting/permissionSettingRequiredLevelList';
import { i18n } from '@/locales';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import UserPermissionSettingDialogController from './UserPermissionSettingDialogController.vue';
import UserPermissionSettingDialogTable from './UserPermissionSettingDialogTable.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const lc = initAutoLc();
        const locale = {
            title: lc('header.title'),
            submit: lc('controller.submit'),
        };
        const isDialogOpen = computed(() => vuexStore.getters['userPermissionSettingDialog/isDialogOpen']);
        const getterTargetUserId = computed(() => vuexStore.getters['userPermissionSettingDialog/getterTargetUserId']);
        const getterIsChanged = computed(() => vuexStore.getters['userPermissionSettingDialog/getterIsChanged']);
        const isFetching = ref(true);
        const isError = ref(false);
        const getUserPermissionList = async () => {
            vuexStore.dispatch('userPermissionSettingDialog/resetUserPermissionList');
            isFetching.value = true;
            isError.value = false;
            try {
                await vuexStore.dispatch('userPermissionSettingDialog/getUserPermissionList');
            }
            catch {
                vuexStore.dispatch('userPermissionSettingDialog/resetStore');
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
                isError.value = true;
            }
            finally {
                isFetching.value = false;
            }
        };
        watch(() => isDialogOpen.value, async (value) => {
            if (!value) {
                return;
            }
            await getUserPermissionList();
        });
        /**
             * 다이얼로그 종료시 초기화
             */
        const handleClickCancelDialogBtn = async () => {
            // 변경사항이 없는 경우
            if (!getterIsChanged.value) {
                vuexStore.dispatch('userPermissionSettingDialog/resetStore');
                return;
            }
            // 변경사항 있으면 알럿
            if (!await vuexStore.dispatch(alertActionType.confirm, {
                headerTitle: lc('confirm_cancel_title'),
                bodyContent: lc('confirm_cancel_message'),
                btnConfig: [
                    {
                        text: 'cancel',
                        cssClass: 'outlined info',
                    },
                    {
                        text: 'ok',
                        cssClass: 'danger',
                    },
                ],
            })) {
                return;
            }
            vuexStore.dispatch('userPermissionSettingDialog/resetStore');
        };
        const handleClickSubmitBtn = async () => {
            const isPermitted = await getRealTimePermission([
                userPermission.P_UPDATE_USER_PERMISSION,
            ], permissionSettingRequiredLevelList);
            // 권한이 없으면 다이얼로그 종료 (이후 다이얼로그 버튼 사라짐)
            if (!isPermitted) {
                vuexStore.dispatch('userPermissionSettingDialog/resetStore');
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
                return;
            }
            try {
                await vuexStore.dispatch('userPermissionSettingDialog/putUserPermissionList');
                vuexStore.dispatch('userPermissionSettingDialog/resetStore');
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: lc('apply_success'),
                });
            }
            catch (error) {
                console.log('userPermissionSettingDialog/handleClickSubmitBtn', error);
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
            }
        };
        onBeforeUnmount(() => {
            vuexStore.dispatch('userPermissionSettingDialog/resetStore');
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createBlock(VerticalDividedDialog, {
                "is-open": isDialogOpen.value,
                "on-cancel": handleClickCancelDialogBtn,
                "is-divided": false,
                "has-footer": false,
                "dialog-css-class": "ratio-full",
                width: 1100,
                "max-height": ""
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(locale.title) + " / " + _toDisplayString(getterTargetUserId.value), 1 /* TEXT */)
                ]),
                leftSubTitle: _withCtx(() => [
                    _createVNode(UserPermissionSettingDialogController)
                ]),
                leftSubInfo: _withCtx(() => [
                    _createCommentVNode(" 권한 적용 버튼 "),
                    _createVNode(_component_v_btn, {
                        class: "align-self-end brg-btn primary size-l",
                        onClick: handleClickSubmitBtn
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode(" mdi-content-save ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [0]
                            }),
                            _createElementVNode("span", _hoisted_1, _toDisplayString(locale.submit), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                leftContent: _withCtx(() => [
                    _createVNode(UserPermissionSettingDialogTable, {
                        "is-error": isError.value,
                        "is-fetching": isFetching.value
                    }, null, 8 /* PROPS */, ["is-error", "is-fetching"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-open"]));
        };
    }
});
